import React, { useContext, useEffect, useState } from "react";
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Label from '../../components/Label';
import SvgIconStyle from '../../components/SvgIconStyle';

import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../../context/Auth/AuthContext";
// ----------------------------------------------------------------------


const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking'),
};


const ConfigUser = () => {

  const { whatsApps } = useContext(WhatsAppsContext);
  const { user } = useContext(AuthContext);
  const [connectionWarning, setConnectionWarning] = useState(false);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (whatsApps.length > 0) {
        const offlineWhats = whatsApps.filter((whats) => {
          return ((
            whats.status === "qrcode" ||
            whats.status === "PAIRING" ||
            whats.status === "DISCONNECTED" ||
            whats.status === "TIMEOUT" ||
            whats.status === "OPENING"
          ));
        });
        if (offlineWhats.length > 0) {
          setConnectionWarning(true);
        } else {
          setConnectionWarning(false);
        }
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps]);


  const navConfig = [
    // GENERAL
    // ----------------------------------------------------------------------
    {
      subheader: 'Menu',
      items: [
        { title: 'Dashboard', path: '/', icon: ICONS.dashboard },
        { title: 'Chats', path: '/chats/', icon: ICONS.ecommerce },
        { title: 'Contacts', path: '/contacts', icon: ICONS.analytics },
      ],
    },
  ];


  if (user.profile === "admin") {
    navConfig.push({
      subheader: 'Administrator',
      items: [
        {
          title: 'Connections',
          path: '/connections',
          icon: ICONS.mail,
          info: (
            <Label variant="outlined" color="error">
              +32
            </Label>
          ),
        },
        { title: 'Users', path: '/users', icon: ICONS.chat },
        { title: 'Respostas rápidas', path: '/quickAnswers', icon: ICONS.calendar },
      ],
    })
  }


  return navConfig;
}
export default ConfigUser;
